import { render, staticRenderFns } from "./CustomerDiscountButton.vue?vue&type=template&id=1db0ae20&scoped=true"
import script from "./CustomerDiscountButton.vue?vue&type=script&lang=js"
export * from "./CustomerDiscountButton.vue?vue&type=script&lang=js"
import style0 from "./CustomerDiscountButton.vue?vue&type=style&index=0&id=1db0ae20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0ae20",
  null
  
)

export default component.exports